import(/* webpackMode: "eager", webpackExports: ["AlertasAgenda"] */ "/app/apps/admin/app/agenda/alertas-agenda.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarVisibilityProvider"] */ "/app/apps/admin/app/components/sidebar-visibility-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/admin/app/components/SideBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/admin/components/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/globals.css");
